export default "__VITE_ASSET__8d2a62d2__"